import Decision from "../Components/Decision";
import Footer from "../Components/Footer";
import Header from "../NewEvent/Header";
import withAuth from "../auth/withAuth";
import ShowUserList from "./ShowUserList";

const UserView = () => {

    return (
      
      <div>
        <Header/>

        <ShowUserList />
        <Decision/>
        <Footer />
      </div>
    );
  }

  export default withAuth(UserView);